<template>
  <div class="screening-font">
    <div style="min-height: 93vh">
      <el-menu class="nav-bar" style="position: fixed" mode="horizontal">
        <img class="nav-bar-logo-image-screening" :src="imagePath" alt="logo">
      </el-menu>
      <br/>
      <div v-show="loadingFlag">
        <el-main class="empty-class" v-loading="true" element-loading-background="rgba(255, 255, 255, 0.5)"
                 element-loading-text="Loading..">
        </el-main>
      </div>
      <div v-show="!loadingFlag" style="margin-top: 10vh;">
        <div class="center-div">
          <div style="width: 97%">
            <div style="float: right">
              <el-button @click="logout">Logout</el-button>
              <br/>
              <br/>
            </div>
            <div v-if="!referToOnlyFlag" style="margin-bottom: 5px">
              <el-radio-group v-model="viewMode">
                <el-radio-button label="all">All</el-radio-button>
                <el-radio-button label="refer">Referral</el-radio-button>
                <el-radio-button label="decline">Decline Request</el-radio-button>
              </el-radio-group>
            </div>
            <br/>
            <div v-if="!referToListFlag && !declineRecommendFlag">
              <div style="font-weight: bold">
                Please first select the academic unit(s) here.
              </div>
              <div style="display: flex">
                <el-checkbox-group v-model="campus" style="margin-top: 10px" @change="campusThrustsConnect">
                  <el-checkbox-button @change="hkThrustSelect" label="hk">HKUST (Hong Kong)</el-checkbox-button>
                </el-checkbox-group>
                <div style="margin-top:auto; margin-left: 30px">
                  Last Name:
                  <el-link @click="alphabetSearch(alpha)" v-for="(alpha, index) in alphabet" :key="index"
                           style="margin-left: 10px; font-size: 15px">{{ alpha }}
                  </el-link>
                </div>
              </div>
              <br/>
              <div style="display: flex">
                <div>
                  <div style="font-weight: bold">
                    Application Status
                  </div>
                  <div style="margin-top: 10px">
                    <el-select v-model="statusSelectOption" placeholder="Select">
                      <el-option
                          v-for="item in statusSelectOptions"
                          :key="item.label"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="margin-left: 20px">
                  <div style="font-weight: bold">
                    Position Applied
                  </div>
                  <div style="margin-top: 10px">
                    <el-select style="width: 14vw" v-model="positions" multiple collapse-tags placeholder="Select">
                      <el-option
                          v-for="item in positionOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!--            <div style="margin-left: 20px" v-if="highPrivilegeCondition() || deanDetection()">-->
                <!--              <div style="font-weight: bold">-->
                <!--                Quick Declined Filter-->
                <!--              </div>-->
                <!--              <div style="height: 75%; align-items: center; display: flex">-->
                <!--              <div style="float: left">-->
                <!--              <el-switch-->
                <!--                  v-model="qdeclinedSwitch"-->
                <!--                  active-text="On"-->
                <!--                  inactive-text="OFF">-->
                <!--              </el-switch>-->
                <!--              </div>-->
                <!--              </div>-->
                <!--            </div>-->
                <div style="margin-left: 20px" v-if="highPrivilegeCondition() || deanDetection()">
                  <div style="font-weight: bold">
                    Quick-Decline Filter
                  </div>
                  <div style="margin-top: 10px">
                    <el-select v-model="qdeclinedSwitch" placeholder="Select">
                      <el-option
                          v-for="item in qdeclinedOptions"
                          :key="item.label"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="margin-left: 20px">
                  <div style="font-weight: bold">
                    Search By
                  </div>
                  <div style="margin-top: 10px">
                    <el-select v-model="selectOption" placeholder="Select">
                      <el-option
                          v-for="item in selectOptions"
                          :key="item.label"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div v-if="selectOption != 'None'" style="margin-top: auto; margin-left: 20px">
                  <el-input style="width: 20vw" v-model="searchKeyWord"
                            @keyup.enter.native="changeSort('search')"></el-input>
                </div>
                <div style="margin-top: auto; margin-left: 20px">
                  <el-button @click="changeSort('search')">Search</el-button>
                  <el-button @click="refresh">Reset Filters</el-button>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>
        <div class="center-div">
          <div style="width: 97%">
            <div style="float: left">
              Search Result: {{ total }}
              <br/>
              <br/>
            </div>
            <div style="float: right">
              1. Index: ✖ = Decline; 👍 = Interview; ★ = Offer; * = Shortlist; ✓ = Sufficient Reviews
            </div>
            <br/>
            <div style="float: right">
              2. Rating scale is from 1 to 10, with 10 being the highest.
            </div>
            <br/>
            <div style="float: right">
              3. The row of candidate whom you have reviewed will change to yellow color.
            </div>
            <br/>
            <div class="center-div" style="margin-bottom: 2vh">
              <el-pagination
                  background
                  @current-change="changeSort(currentOrder)"
                  :current-page.sync="currentPage"
                  :page-size="pageItemNum"
                  :pager-count="7"
                  layout="prev, pager, next"
                  :total="total">
              </el-pagination>
            </div>
            <el-table
                size="mini"
                :row-class-name="scoredRow"
                ref="screeningTable"
                @sort-change="changeSort"
                border
                :data="records"
                :cell-style="getTableCellStyle"
                :header-cell-style="getTableCellStyle"
                :default-sort="defaultSort"
                class="record-table">
              <el-table-column
                  width="60">
                <template slot-scope="scope">
                  {{ scope.$index + 1 + (currentPage - 1) * pageItemNum }}
                </template>
              </el-table-column>
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  :min-width="30"
                  label="Unit"
                  prop="declineUnit"
                  v-if="declineRecommendFlag"
                  sortable="custom"
                  key="0">
                <template slot-scope="scope">
                  <el-tag size="mini" effect="dark" :color="otherHubCheckBoxColor(scope.row.declinedUnit)"
                          :class="otherHubCheckBoxClass(scope.row.declinedUnit)"
                          v-if="declineUnitCampus(scope.row.declineUnit, scope.row.areas) == 'gz'">
                    {{ getAbbreviation(scope.row.declineUnit) }}
                  </el-tag>
                  <el-tag size="mini" effect="dark"
                          v-if="declineUnitCampus(scope.row.declineUnit, scope.row.areas) == 'hk'"
                          style="margin-left: 10px; margin-top:5px; margin-bottom: 5px;">
                    {{ getAbbreviation(scope.row.declineUnit) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  :min-width="50"
                  label="Requester"
                  v-if="declineRecommendFlag"
                  key="1">
                <template slot-scope="scope">
                  {{ scope.row.Requester }}
                </template>
              </el-table-column>
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  :min-width="40"
                  label="Status"
                  key="2">
                <template slot-scope="scope">
                  <div>
                    <el-tag size="mini" effect="dark" style="border-color: #EB4139" color="#EB4139"
                            v-if="scope.row.screenStatus === statusNameJson['Decline']">
                      Decline
                    </el-tag>
                    <el-tag size="mini" effect="dark" style="border-color: #39CDEB" color="#39CDEB"
                            v-if="scope.row.screenStatus === statusNameJson['Interview']">
                      Interview
                    </el-tag>
                    <el-tag size="mini" effect="dark" type="info"
                            v-if="scope.row.screenStatus === statusNameJson['Pending']">
                      Pending
                    </el-tag>
                    <el-tag size="mini" effect="dark" color="#ff9900" style="border-color: #ff9900"
                            v-if="scope.row.screenStatus === statusNameJson['Ref Needed']">
                      Ref Needed
                    </el-tag>
                    <el-tag size="mini" effect="dark" color="#8cff66" style="border-color: #8cff66"
                            v-if="scope.row.screenStatus === statusNameJson['Offer']">
                      Offer
                    </el-tag>
                    <el-tag size="mini" effect="dark" color="#cc0099" style="border-color: #cc0099"
                            v-if="scope.row.screenStatus === statusNameJson['Shortlist']">
                      Shortlist
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  prop="name"
                  sortable="custom"
                  :min-width="90"
                  label="Name"
                  key="3">
                <template slot-scope="scope">
                  <el-link style="font-weight: bold" type="primary" :underline="false"
                           @click="getPersonalInfo(scope.row.applicantID, scope.row.declineUnit, scope.row.requesterId)">
                    {{ scope.row.lastname }},
                    {{ scope.row.firstname }}
                  </el-link>
                </template>
              </el-table-column>
              <!--            <el-table-column-->
              <!--                label-class-name="table-black-header"-->
              <!--                align="left"-->
              <!--                sortable="custom"-->
              <!--                prop="lastUpdate"-->
              <!--                :min-width="60"-->
              <!--                label="Last Updated">-->
              <!--              <template slot-scope="scope">-->
              <!--                <div v-if="scope.row.lastUpdated">-->
              <!--                  {{ scope.row.lastUpdated.split('T')[0] }}-->
              <!--                </div>-->
              <!--                &lt;!&ndash;                  <div>&ndash;&gt;-->
              <!--                &lt;!&ndash;                    ({{ scope.row.lastUpdated.split('T')[0] }})&ndash;&gt;-->
              <!--                &lt;!&ndash;                  </div>&ndash;&gt;-->
              <!--              </template>-->
              <!--            </el-table-column>-->
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  sortable="custom"
                  prop="received"
                  :min-width="75"
                  label="Received"
                  key="4">
                <el-table-column
                    label-class-name="table-black-header"
                    align="left"
                    sortable="custom"
                    prop="lastUpdate"
                    :min-width="75"
                    label="(Last Updated)">
                  <template slot-scope="scope">
                    <div v-if="scope.row.lastUpdated">
                      {{ getSubYear(scope.row.received.split(' ')[0]) }}
                      ({{ getSubYear(scope.row.lastUpdated.split(' ')[0]) }})
                    </div>
                    <!--                  <div>-->
                    <!--                    ({{ scope.row.lastUpdated.split('T')[0] }})-->
                    <!--                  </div>-->
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  prop="degreeYearDuration"
                  :min-width="120"
                  label="Degree Year"
                  v-if="!declineRecommendFlag"
                  key="5">
                <template slot-scope="scope">
                  <!--                {{scope.row.highestDegreeInfo}}-->
                  <div v-for="(degreeInfo,index) in scope.row.highestDegreeInfo" :key="index">
                    <!--                  <div>-->
                    <!--                    {{ getUniversityName(degreeInfo.university) }}-->
                    <!--                  </div>-->
                    <div v-if="!degreeInfo.to_present">
                      {{ getabbForAffiliationAndUniversity(degreeInfo.university) }}
                      ({{ displayDegreeInfoTimeRange(degreeInfo.end) }})
                      {{ degreeAbbreviation(degreeInfo.degree) }}
                    </div>
                    <div v-if="degreeInfo.to_present">
                      {{ getabbForAffiliationAndUniversity(degreeInfo.university) }}
                      (Present)
                      {{ degreeAbbreviation(degreeInfo.degree) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :min-width="120"
                  label-class-name="table-black-header"
                  align="left"
                  prop="affiliation"
                  label="Affiliation"
                  key="6">
                <template slot-scope="scope">
                  <div>
                    {{ wordingSlice(getabbForAffiliationAndUniversity(scope.row.affiliation_institution), 30) }}
                    ({{ positionAbbreviation(scope.row.affiliation_position) }})
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  :min-width="100"
                  label="Academic Unit/ Priority Area"
                  key="7">
                <template slot-scope="scope">
                  <!--                <div v-if="campus.includes('gz') && scope.row.areas.gz.length > 0">-->
                  <!--                  <p>Guangzhou Campus</p>-->
                  <el-tag size="mini" effect="dark" :color="otherHubCheckBoxColor(gz[0])"
                          :class="otherHubCheckBoxClass(gz[0])"
                          v-for="(gz,index) in scope.row.areas.gz" :key="index">
                    {{ getAbbreviation(gz[0]) }}{{ status(gz[1]) }}
                  </el-tag>
                  <!--                  <br/>-->
                  <!--                  <br v-if="campus.includes('hk') && scope.row.areas.hk.length > 0"/>-->
                  <!--                </div>-->
                  <!--                <div v-if="campus.includes('hk') && scope.row.areas.hk.length > 0" style="margin-top: 10px">-->
                  <!--                  <p>Hong Kong Campus</p>-->
                  <el-tag size="mini" effect="dark" v-for="(hk,index) in scope.row.areas.hk"
                          :color="otherHubCheckBoxColor(hk[0], 'hk')"
                          :class="otherHubCheckBoxClass(hk[0], 'hk')"
                          style="margin-left: 10px; margin-top:5px; margin-bottom: 5px;"
                          :key="index + scope.row.areas.gz.length">
                    {{ getAbbreviation(hk[0]) }}{{ status(hk[1]) }}
                  </el-tag>
                  <!--                </div>-->
                </template>
              </el-table-column>
              <el-table-column
                  label-class-name="table-key-header"
                  align="left"
                  :min-width="45"
                  prop="totalAvg"
                  sortable="custom"
                  label="Avg/ Reviewer #"
                  key="8">
                <template slot-scope="scope">
                  <div v-if="scope.row.totalAvg > -1" class="table-black-content">
                    {{ scope.row.totalAvg.toPrecision(2) }}/{{ scope.row.reviewerNum }}
                  </div>
                </template>
              </el-table-column>
              <!--            <el-table-column-->
              <!--                label-class-name="table-key-header"-->
              <!--                align="center"-->
              <!--                :min-width="tableParameter.numberHeaderWidth"-->
              <!--                sortable="custom"-->
              <!--                prop="reviewerNum"-->
              <!--                label="# of Reviewer">-->
              <!--              <template slot-scope="scope">-->
              <!--                <div class="table-black-content">-->
              <!--                  {{scope.row.reviewerNum}}-->
              <!--                </div>-->
              <!--              </template>-->
              <!--            </el-table-column>-->
              <!--            <el-table-column-->
              <!--                label-class-name="table-black-header"-->
              <!--                align="center"-->
              <!--                :min-width="tableParameter.numberHeaderWidth"-->
              <!--                sortable="custom"-->
              <!--                prop="totalSd"-->
              <!--                label="SD">-->
              <!--              <template slot-scope="scope">-->
              <!--                <div v-if="scope.row.totalSd > -1">-->
              <!--                  {{scope.row.totalSd.toPrecision(2)}}-->
              <!--                </div>-->
              <!--              </template>-->
              <!--            </el-table-column>-->
              <!--            <el-table-column-->
              <!--                label-class-name="table-key-header"-->
              <!--                align="center"-->
              <!--                sortable="custom"-->
              <!--                prop="highestThrustOrDept"-->
              <!--                label="Highest Thrust Name">-->
              <!--              <template slot-scope="scope">-->
              <!--                <div v-if="scope.row.highestThrustOrDept.length > 0">-->
              <!--                  {{getAbbreviation(scope.row.highestThrustOrDept[0])+' ('+scope.row.highestThrustOrDept[1]+')'}}-->
              <!--                </div>-->
              <!--              </template>-->
              <!--            </el-table-column>-->
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  :min-width="65"
                  sortable="custom"
                  prop="highestAvg"
                  label="Highest Unit Avg/ Reviewer #"
                  key="9">
                <template slot-scope="scope">
                  <div v-if="scope.row.highestAvg > -1" class="table-black-content">
                    {{ scope.row.highestAvg.toPrecision(2) }}/{{ scope.row.highestReviewerNum }}
                    <el-tag size="mini" v-if="scope.row.highestThrustOrDept[1] === 'gz'" effect="dark"
                            :color="otherHubCheckBoxColor(scope.row.highestThrustOrDept[0])"
                            :style="'border-color:'+otherHubCheckBoxColor(scope.row.highestThrustOrDept[0])">
                      {{ getAbbreviation(scope.row.highestThrustOrDept[0]) }}
                    </el-tag>
                    <el-tag size="mini" v-if="scope.row.highestThrustOrDept[1] === 'hk'" effect="dark"
                            :color="otherHubCheckBoxColor(scope.row.highestThrustOrDept[0], 'hk')"
                            :style="'border-color:'+otherHubCheckBoxColor(scope.row.highestThrustOrDept[0], 'hk')">
                      {{ getAbbreviation(scope.row.highestThrustOrDept[0]) }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <!--            <el-table-column-->
              <!--                label-class-name="table-black-header"-->
              <!--                align="center"-->
              <!--                :min-width="tableParameter.numberHeaderWidth"-->
              <!--                sortable="custom"-->
              <!--                prop="highestReviewerNum"-->
              <!--                label="Highest Unit # of Reviewer">-->
              <!--              <template slot-scope="scope">-->
              <!--              <div v-if="scope.row.highestReviewerNum > -1">-->
              <!--                {{scope.row.highestReviewerNum}}-->
              <!--              </div>-->
              <!--              </template>-->
              <!--            </el-table-column>-->
              <!--            <el-table-column-->
              <!--                label-class-name="table-black-header"-->
              <!--                align="center"-->
              <!--                :min-width="tableParameter.numberHeaderWidth"-->
              <!--                sortable="custom"-->
              <!--                prop="highestSd"-->
              <!--                label="Highest Unit SD">-->
              <!--              <template slot-scope="scope">-->
              <!--                <div v-if="scope.row.highestSd > -1">-->
              <!--                  {{scope.row.highestSd.toPrecision(2)}}-->
              <!--                </div>-->
              <!--              </template>-->
              <!--            </el-table-column>-->
              <el-table-column
                  label-class-name="table-black-header"
                  align="left"
                  :min-width="40"
                  label="Decline Status"
                  prop="declineStatus"
                  v-if="declineRecommendFlag"
                  sortable="custom"
                  key="10">
                <template slot-scope="scope">
                  {{ scope.row.declineStatus }}
                </template>
              </el-table-column>
              <!--            <el-table-column-->
              <!--                label-class-name="table-black-header"-->
              <!--                align="left"-->
              <!--                :min-width="40"-->
              <!--                label="Action"-->
              <!--                v-if="declineRecommendFlag"-->
              <!--                key = "11">-->
              <!--&lt;!&ndash;              <template slot-scope="scope">&ndash;&gt;-->

              <!--&lt;!&ndash;              </template>&ndash;&gt;-->
              <!--            </el-table-column>-->
            </el-table>
          </div>
        </div>
        <div class="center-div" style="margin-top: 2vh; margin-bottom: 2vh">
          <el-pagination
              background
              @current-change="changeSort(currentOrder)"
              :current-page.sync="currentPage"
              :page-size="pageItemNum"
              :pager-count="7"
              layout="prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </div>
      <el-dialog
          :visible.sync="infoFlag"
          v-if="infoFlag"
          width="80%"
          center>
      <span class="center-div">
          <el-button type="primary" @click="getReviewDetail">View All Ratings and Comments</el-button>
          <el-button type="primary" @click="showComment">Evaluate the Candidate</el-button>
          <el-button type="primary" @click="showDocuments">Show Documents</el-button>
          <el-button v-if="(this.screenIdentity === 'internal')" type="primary" @click="showReference">Refer To Other Reviewer</el-button>
          <!-- <el-button @click="showECheckList">View e-check list</el-button> -->
        <!--          <el-button type="primary" @click="showTimeline">Status Timeline</el-button>-->
      </span>
        <ScreeningPersonalInfo :template-data="personalData" :thrust-points="thrustPoints" :userName="currentApplicant"
                               :reviewerId="this.uid"
                               :referenceLetterInfo="referenceLetterInfo" :available-unit="currentAvailableThrust"
                               :thrustStatus="thrustStatus"
                               :refer-to-list-flag="referToListFlag"
                               :qDeclineReviewerInfo="qDeclineReviewerInfo"
                               :declineRecommendFlag="declineRecommendFlag"
                               :currentDeclinedUnit="currentDeclinedUnit"
                               :currentDeclinedRequester="currentDeclinedRequester"
                               :role="currentRoleList" v-on:dataChanged="changeSort(val, 'update')"
                               :preboardingFlag="preboardingFlag"
                               v-on:updatePersonalData="updatePersonalData"></ScreeningPersonalInfo>
        <span class="center-div">
          <el-button type="primary" @click="getReviewDetail">View All Ratings and Comments</el-button>
          <el-button type="primary" @click="showComment">Evaluate the Candidate</el-button>
          <el-button type="primary" @click="showDocuments">Show Documents</el-button>
          <el-button v-if="(this.screenIdentity === 'internal')" type="primary" @click="showReference">Refer To Other Reviewer</el-button>
          <el-button @click="showECheckList">View e-check list</el-button>
        </span>
      </el-dialog>
      <el-dialog
          @close="infoFlag = true"
          :visible.sync="eCheckListFlag"
          v-if="eCheckListFlag"
          width="50%"
          center>
        <pre-e-check-list :applicant-id="currentApplicant" :unitList="personalData.thrust" v-on:toECheckListEvent="closeECheckList()"></pre-e-check-list>
      </el-dialog>
      <el-dialog
          :visible.sync="referenceEmailFlag"
          v-if="referenceEmailFlag"
          width="40%">
        <template slot="title">
          Refer To Other Reviewer
          <el-popover
              placement="top-start"
              width="500"
              trigger="hover"
              :content="description.referToOtherReviewer">
            <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>
          </el-popover>
        </template>
        <!--      <div>-->
        <!--        <el-select v-model="referToType" placeholder="Select">-->
        <!--          <el-option-->
        <!--              v-for="item in referToTypeOptions"-->
        <!--              :key="item.value"-->
        <!--              :label="item.label"-->
        <!--              :value="item.value">-->
        <!--          </el-option>-->
        <!--        </el-select>-->
        <!--      </div>-->
        <div>
          <span style="margin-left: 10px">Name:</span>
          <el-autocomplete
              v-if="referToType === 'internal'"
              style="width:10vw; margin-top: 5px; margin-left: 10px"
              v-model="referToOtherName"
              :fetch-suggestions="referNameSearch"
              :trigger-on-focus="false"
          ></el-autocomplete>
          <el-input
              v-else
              style="width:10vw; margin-top: 5px; margin-left: 10px"
              v-model="referToOtherName"
          ></el-input>
        </div>
        <div>
          <span style="margin-left: 10px">Email:</span>
          <el-input v-model="referToOtherEmail" style="width:10vw; margin-top: 5px; margin-left: 10px"></el-input>
        </div>
        <div v-if="referToOtherEmailList.length != 0" style="margin-top: 10px">
          <div :key="index"
               v-for="(reviewer,index) in this.referToOtherEmailList" style="margin-bottom: 5px;">
            <el-tag
                closable
                :disable-transitions="false"
                @close="deleteReferToOtherList(reviewer)">
              {{ reviewer["name"] }}({{ reviewer["email"] }})
            </el-tag>
          </div>
        </div>
        <div style="margin-top: 10px">
          <el-button @click="AddReferToOtherToList">
            Add More Reviewer
          </el-button>
        </div>
        <div style="margin-top: 10px">
          <el-button type="primary" @click="sendReferToOther">
            Send
          </el-button>
        </div>
        <!--      <div v-if="referToOtherEmailList.length != 0" style="margin-top: 10px">-->
        <!--        <el-button type="primary" @click="sendReferToOther">-->
        <!--          Send-->
        <!--        </el-button>-->
        <!--      </div>-->
      </el-dialog>
      <el-dialog
          title="HKUST (Hong Kong)"
          :visible.sync="hkThrustSelectorFlag"
          v-if="hkThrustSelectorFlag"
          width="80%"
          center>
        <el-checkbox border :indeterminate="hkIndeterminate" v-model="hkCheckAll" @change="hkHandleCheckAllChange">Check
          all
        </el-checkbox>
        <br/>
        <br/>
        <div>
          <el-row :gutter="20">
            <el-col :span="24">
              <ScreeningDepartmentViewingComponent
                  :data-list="hkFacultyDetail.Strategic_Hiring"
                  :content="campusDetail.hk"
                  data-header="Strategic Hiring" data-notation="hk"
                  :availableUnit="currentAvailableThrust"
                  :green-check-box="true"
                  :role="highPrivilegeCondition()"
                  v-on:departmentDataUpdate="departmentDataUpdateHandler"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
          <br/>

          <el-row :gutter="20">
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="hkFacultyDetail.Science"
                                                   :content="campusDetail.hk"
                                                   data-header="School of Science" data-notation="hk"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   :box-min-height="hkEngineerHeight"></ScreeningDepartmentViewingComponent>
            </el-col>
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="hkFacultyDetail.Engineering"
                                                   :content="campusDetail.hk"
                                                   data-header="School of Engineering" data-notation="hk"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   ref="hkEngineerDept"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
          <br/>
          <el-row :gutter="20">
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="hkFacultyDetail.Business"
                                                   :content="campusDetail.hk"
                                                   data-header="School of Business and Management" data-notation="hk"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   ref="hkBusinessDept"></ScreeningDepartmentViewingComponent>
            </el-col>
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="hkFacultyDetail.Humanities_and_Social_Science"
                                                   :content="campusDetail.hk"
                                                   data-header="School of Humanities and Social Science"
                                                   data-notation="hk" :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   :box-min-height="hkBusinessHeight"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
          <br/>
          <el-row :gutter="20">
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent
                  :data-list="hkFacultyDetail.Interdisciplinary_Programs_Office"
                  :content="campusDetail.hk"
                  data-header="Academy of Interdisciplinary Studies" data-notation="hk"
                  :availableUnit="currentAvailableThrust"
                  :role="highPrivilegeCondition()"
                  v-on:departmentDataUpdate="departmentDataUpdateHandler"
                  ref="hkIPODept"></ScreeningDepartmentViewingComponent>
            </el-col>
            <el-col :span="12" v-if="highPrivilegeCondition()">
              <el-card :style="{'min-height': hkIPOHeight}">
                <div slot="header">
                  <span class="header-class">Priority Areas</span>
                </div>
                <div>
                  <el-checkbox-group v-model="campusDetail.hk"
                                     v-on:change="departmentDataUpdateHandler(campusDetail.hk,'hk')">
                    <div v-for="(thrustDetail,index) in hkFacultyDetail.Others_HK" :key="index">
                      <el-checkbox
                          v-if="unitAvailability(thrustDetail.name) || highPrivilegeCondition()"
                          class="green-checkbox" :label="thrustDetail.name">
                        <div class="checkbox-class">
                          <p class="checkbox-label">{{
                              correctThrust(thrustDetail.name, true) + ' (' + getAbbreviation(thrustDetail.name) + ')'
                            }}</p>
                        </div>
                      </el-checkbox>
                      <el-checkbox
                          v-if="!unitAvailability(thrustDetail.name) && !highPrivilegeCondition()"
                          disabled class="green-checkbox" :label="thrustDetail.name">
                        <div class="checkbox-class">
                          <p class="checkbox-label">{{
                              correctThrust(thrustDetail.name, true) + ' (' + getAbbreviation(thrustDetail.name) + ')'
                            }}</p>
                        </div>
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeSort('search')">Confirm</el-button>
      </span>

      </el-dialog>
      <el-dialog
          title="HKUST (Guangzhou)"
          :visible.sync="gzThrustSelectorFlag"
          v-if="gzThrustSelectorFlag"
          width="80%"
          center>
        <el-checkbox class="gold-checkbox" border :indeterminate="gzIndeterminate" v-model="gzCheckAll"
                     @change="gzHandleCheckAllChange">Check all
        </el-checkbox>
        <br/>
        <br/>
        <div style="margin-top: 20px">
          <el-row :gutter="20">
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Function"
                                                   :content="campusDetail.gz" 
                                                   :thrustPrefix="'Thrust of '"
                                                   data-header="Function Hub" data-notation="gz"
                                                  :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   :box-min-height="gzInfoHubHeight"></ScreeningDepartmentViewingComponent>
            </el-col>
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Information"
                                                   :content="campusDetail.gz"
                                                   :thrustPrefix="'Thrust of '"
                                                   data-header="Information Hub" data-notation="gz"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   ref="gzInfoHub"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
          <br/>
          <el-row :gutter="20">
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Systems"
                                                   :content="campusDetail.gz"
                                                   :thrustPrefix="'Thrust of '"
                                                   data-header="Systems Hub" data-notation="gz"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   :box-min-height="gzSociHubHeight"></ScreeningDepartmentViewingComponent>
            </el-col>
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Society"
                                                   :content="campusDetail.gz"
                                                   :thrustPrefix="'Thrust of '"
                                                   data-header="Society Hub" data-notation="gz"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   ref="gzSociHub"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
          <br/>
          <el-row :gutter="20">
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Education_Sciences"
                                                   :content="campusDetail.gz"
                                                   data-header="College of Education Sciences" data-notation="gz"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   ref="gzEduSci"></ScreeningDepartmentViewingComponent>
            </el-col>
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Future_Technology"
                                                   :content="campusDetail.gz"
                                                   data-header="College of Future Technology" data-notation="gz"
                                                   :availableUnit="currentAvailableThrust"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   :box-min-height="gzEduSciHeight"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
          <br/>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-card ref="gzPriority">
                <div slot="header">
                  <span class="header-class">Priority Areas</span>
                </div>
                <div>
                  <el-checkbox-group v-model="campusDetail.gz"
                                     v-on:change="departmentDataUpdateHandler(campusDetail.gz,'gz')">
                    <div v-for="(thrustDetail,index) in gzThrustDetail.Others" :key="index">
                      <el-checkbox
                          v-if="unitAvailability(thrustDetail.name) || highPrivilegeCondition()"
                          class="green-checkbox" :label="thrustDetail.name">
                        <div class="checkbox-class">
                          <p class="checkbox-label">{{
                              correctThrust(thrustDetail.name, true) + ' (' + getAbbreviation(thrustDetail.name) + ')'
                            }}</p>
                        </div>
                      </el-checkbox>
                      <el-checkbox
                          v-if="!unitAvailability(thrustDetail.name) && !highPrivilegeCondition()"
                          disabled class="green-checkbox" :label="thrustDetail.name">
                        <div class="checkbox-class">
                          <p class="checkbox-label">{{
                              correctThrust(thrustDetail.name, true) + ' (' + getAbbreviation(thrustDetail.name) + ')'
                            }}</p>
                        </div>
                      </el-checkbox>
                    </div>
                    <el-checkbox
                        v-if="unitAvailability('Others') || highPrivilegeCondition()"
                        class="green-checkbox" label="Others">
                      <div class="checkbox-class">
                        <p class="checkbox-label">{{ correctThrust('Others', true) }}</p>
                      </div>
                    </el-checkbox>
                    <el-checkbox
                        v-if="!unitAvailability('Others') && !highPrivilegeCondition()"
                        disabled class="green-checkbox" label="Others">
                      <div class="checkbox-class">
                        <p class="checkbox-label">{{ correctThrust('Others', true) }}</p>
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <ScreeningDepartmentViewingComponent :data-list="gzThrustDetail.Research"
                                                   :content="campusDetail.gz"
                                                   data-header="Research Infrastructure" data-notation="gz"
                                                   :availableUnit="currentAvailableThrust"
                                                   :green-check-box="true"
                                                   :role="highPrivilegeCondition()"
                                                   v-on:departmentDataUpdate="departmentDataUpdateHandler"
                                                   :box-min-height="gzPriorityHeight"></ScreeningDepartmentViewingComponent>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeSort('search')">Confirm</el-button>
      </span>
      </el-dialog>
      <el-dialog
          @close="infoFlag = true"
          title="View All Ratings and Comments"
          :visible.sync="commentDetailFlag"
          v-if="commentDetailFlag"
          width="80%"
          center>
        <el-select v-model="pointsOption" placeholder="Search Unit" style="margin-bottom: 20px; margin-right: 20px">
          <el-option
              v-for="item in pointsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        Number of Reviews: {{ reviews.length }}
        <div v-if="reviews.length != 0">
          <el-collapse v-model="collapseExpand">
            <el-collapse-item v-for="(review,index) in this.reviews" :title="getReviewerName(review, index)"
                              :name="'comment_'+index" :key="index">
              <div v-for="(point,pIndex) in review.points" :key="pIndex">
                <el-tag size="mini" v-if="point[2] == 'gz'" effect="dark" :color="otherHubCheckBoxColor(point[0])"
                        :style="'border-color: '+otherHubCheckBoxColor(point[0])+'; margin-top: 5px; margin-bottom: 5px'">
                  {{ getAbbreviation(point[0]) }} : {{ point[1] }}
                </el-tag>
                <el-tag size="mini" v-if="point[2] == 'hk'" effect="dark" :color="otherHubCheckBoxColor(point[0], 'hk')"
                        :style="'border-color: '+otherHubCheckBoxColor(point[0], 'hk')+'; margin-top: 5px; margin-bottom: 5px'">
                  {{ getAbbreviation(point[0]) }} : {{ point[1] }}
                </el-tag>
                <!--            {{ point[0] }}({{ point[2] }}) : {{ point[1] }}-->
              </div>
              <div>
                comment: {{ review.comment }}
              </div>
              <div>
                relationship: {{ review.relationship }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-else class="center-div">
          <div>
            No data
          </div>
        </div>
      </el-dialog>
      <el-dialog
          @close="infoFlag = true"
          title="Documents"
          :visible.sync="documentFlag"
          v-if="documentFlag"
          width="80%"
          center>
        <ScreeningDocumentComponent v-if="personalData.documents"
                                    :screening-upload-file-rights="localScreeningUploadFileRights"
                                    v-on:updatePersonalData="updatePersonalDataDocumentChanged"
                                    :documents="personalData.documents"
                                    :applicantName="personalData.english_last_name+'_'+personalData.english_first_name"
                                    :uid="uid" :originalDocuments="originalDocuments" :applicantId="currentApplicant"
                                    :applicantStatus="personalData.applicant_status"></ScreeningDocumentComponent>
      </el-dialog>
      <el-dialog
          @close="infoFlag = true"
          title="Evaluate the Candidate"
          :visible.sync="commentFlag"
          v-if="commentFlag"
          width="80%"
          center>
        <el-row :gutter="20">
          <el-col :span="10">
            <!--          <p style="text-align: center">HKUST(Guangzhou)</p>-->
            <el-table
                :data="gzScoreDocuments" v-if="gzScoreDocuments.length > 0">
              <el-table-column
                  min-width="40"
                  label="Rating (From 1 to 10, with 10 being the highest)">
                <template slot-scope="scope">
                  <div class="center-div">
                    <el-tooltip class="item" :content="correctThrust(scope.row.name)" placement="top-start">
                      <el-tag effect="dark" :color="otherHubCheckBoxColor(scope.row.name)"
                              :style="'border-color: '+otherHubCheckBoxColor(scope.row.name)">
                        {{ getAbbreviation(scope.row.name) }}
                      </el-tag>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-input-number
                      :min="1" :max="10"
                      :step="0.5" step-strictly
                      v-model="scope.row.score"></el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="10">
            <!--          <p style="text-align: center">HKUST(Hong Kong)</p>-->
            <el-table
                :data="hkScoreDocuments" v-if="hkScoreDocuments.length > 0">
              <el-table-column
                  min-width="40"
                  label="Rating (From 1 to 10, with 10 being the highest)">
                <template slot-scope="scope">
                  <div class="center-div">
                    <el-tooltip class="item" :content="correctThrust(scope.row.name)" placement="top-start">
                      <el-tag effect="dark" :color="otherHubCheckBoxColor(scope.row.name, 'hk')"
                              :style="'border-color: '+otherHubCheckBoxColor(scope.row.name,'hk')">
                        {{ getAbbreviation(scope.row.name) }}
                      </el-tag>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-input-number
                      :min="1" :max="10"
                      :step="0.5" step-strictly
                      v-model="scope.row.score">
                  </el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <br/>
        <p>Comment</p>
        <el-input
            type="textarea"
            :rows="6"
            placeholder="Please input your comment here"
            v-model="comment">
        </el-input>
        <br/>
        <br/>
        <p>Your relationship with the candidate (if any)</p>
        <el-select v-model="relation" placeholder="Select Relationship">
          <el-option
              v-for="item in relationOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button style="margin-left: 10px" @click="clearRelationship">
          Clear
        </el-button>
        <br/>
        <br/>
        <el-input style="width: 30vw" v-model="otherRelation" v-if="relation === 'Others'">
        </el-input>
        <!--      <p>Status</p>-->
        <!--      <el-select v-model="screeningStatus" placeholder="Select Status">-->
        <!--        <el-option-->
        <!--            v-for="item in statusOptions"-->
        <!--            :key="item.value"-->
        <!--            :label="item.label"-->
        <!--            :value="item.value">-->
        <!--        </el-option>-->
        <!--      </el-select>-->
        <!--      <el-button style="margin-left: 10px" @click="clearRelationship">-->
        <!--        Clear-->
        <!--      </el-button>-->
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitComment">Submit</el-button>
      </span>
      </el-dialog>
      <!--      <DesktopFooter></DesktopFooter>-->
    </div>
    <div>
      <DesktopFooter></DesktopFooter>
    </div>
  </div>
</template>

<script>
import ScreeningPersonalInfo from "@/basic_components/ScreeningPersonalInfo";
import PreECheckList from "@/basic_components/PreECheckList";
import {Message} from "element-ui";
import utilsMixin from "@/components/view/js/utilsMixin";
import logoutMixin from "@/components/view/js/logoutMixin";
import referToOtherMixin from "@/components/view/js/referToOtherMixin";
// import DepartmentViewingComponent from "@/basic_components/DepartmentViewingComponent";
import screeningUtilsMixin from "@/components/view/js/screeningUtilsMixin";
import gzThrustjson from "@/assets/json/gzThrust.json";
import hkFacultyjson from "@/assets/json/hkFacultyDepartments.json";
import Vue from "vue"
import ScreeningDepartmentViewingComponent from "@/basic_components/ScreeningDepartmentViewingComponent";
import DesktopFooter from "@/basic_components/DesktopFooter";
import statusJson from "@/assets/json/status.json"
import statusNameJson from "@/assets/json/statusName.json"
import roles from "@/assets/json/role.json"
import thrustCorrectionMixin from "@/components/view/js/thrustCorrectionMixin";
import accessName from "@/assets/json/accessName.json"
import accessNameEmail from "@/assets/json/accessNameEmail.json"
import screeningAbbreviationMixin from "@/components/view/js/screeningAbbreviationMixin";
import screeningSelectorMixin from "@/components/view/js/screeningSelectorMixin";
import ScreeningDocumentComponent from "@/basic_components/ScreeningDocumentComponent";
import description from "@/assets/json/description.json"
import {screeningUploadFileRights} from "@/data/screeningConfig"

export default {
  name: "ScreeningPage",
  components: {
    ScreeningPersonalInfo,
    ScreeningDepartmentViewingComponent,
    DesktopFooter,
    ScreeningDocumentComponent,
    PreECheckList
  },
  mixins: [utilsMixin, logoutMixin, thrustCorrectionMixin, referToOtherMixin, screeningAbbreviationMixin, screeningSelectorMixin, screeningUtilsMixin],
  data() {
    return {
      localScreeningUploadFileRights: screeningUploadFileRights,
      screenIdentity: "",
      referToType: "internal",
      referToTypeOptions: [
        {
          value: 'internal',
          label: 'internal'
        },
        {
          value: 'external',
          label: 'external'
        }],
      yAxisOffset: 0,
      currentDeclinedUnit: "",
      qDeclineReviewerInfo: [],
      collapseExpand: [],
      qdeclinedSwitch: false,
      qdeclinedOptions: [
        {
          value: true,
          label: 'On'
        },
        {
          value: false,
          label: 'OFF'
        },
      ],
      val: {prop: 'received', order: 'descending'},
      defaultSort: {prop: 'received', order: 'descending'},
      description: description,
      currentOrder: {"prop": "", "order": ""},
      viewMode: "all",
      referToOnlyFlag: false,
      referToListFlag: false,
      declineRecommendFlag: false,
      applicantList: [],
      accessName: accessName,
      accessNameEmail: accessNameEmail,
      referToOtherName: '',
      referToOtherEmail: '',
      referToOtherEmailList: [],
      imagePath: require('@/assets/img/Recruitment System (Screening and Evaluation) - UST.svg'),
      imagePathRight: require('@/assets/img/HKUST(GZ)_logo.svg'),
      roles: roles,
      currentAvailableThrust: [],
      currentRoleList: {},
      loadingFlag: false,
      pageItemNum: 50,
      currentPage: 1,
      alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      campus: ['gz', 'hk'],
      campusDetail: {"gz": [], "hk": []},
      statusJson: statusJson,
      statusNameJson: statusNameJson,
      hkCheckAll: false,
      hkIndeterminate: false,
      gzCheckAll: false,
      gzIndeterminate: false,
      records: [],
      prevApplicant: '',
      infoFlag: false,
      eCheckListFlag: false,
      documentFlag: false,
      commentFlag: false,
      gzThrustDetail: gzThrustjson,
      hkFacultyDetail: hkFacultyjson,
      gzLengthOriginal: 0,
      hkLengthOriginal: 0,
      gzThrustSelectorFlag: false,
      hkThrustSelectorFlag: false,
      commentDetailFlag: false,
      thrustStatus: {},
      relation: '',
      otherRelation: '',
      pointsOptions: [],
      pointsOption: [],
      positions: ["Full Professor", "Associate Professor", "Assistant Professor", "Research Track", "Teaching Track", "Visiting Faculty"],
      positionOptions: [
        {
          value: 'Full Professor',
          label: 'Full Professor'
        },
        {
          value: 'Associate Professor',
          label: 'Associate Professor'
        },
        {
          value: 'Assistant Professor',
          label: 'Assistant Professor'
        },
        {
          value: 'Research Track',
          label: 'Research Track'
        },
        {
          value: 'Teaching Track',
          label: 'Teaching Track'
        },
        {
          value: 'Visiting Faculty',
          label: 'Visiting Faculty'
        },
      ],
      relationOptions: [
        {
          value: 'Advisor/ Student',
          label: 'Advisor/ Student'
        }, {
          value: 'Same Advisor',
          label: 'Same Advisor'
        }, {
          value: 'Co-author/ Co-PI',
          label: 'Co-author/ Co-PI'
        }, {
          value: 'Relative',
          label: 'Relative'
        }, {
          value: 'Others',
          label: 'Others'
        }
      ],
      statusOptions: [
        {
          value: 'Recommend for Interview',
          label: 'Recommend for Interview'
        }, {
          value: 'Hold',
          label: 'Hold'
        }, {
          value: 'Decline',
          label: 'Decline'
        }
      ],
      referenceEmailFlag: false,
      screeningStatus: '',
      gzScoreDocuments: [],
      hkScoreDocuments: [],
      comment: '',
      personalData: {},
      originalDocuments: [],
      thrustPoints: {},
      referenceLetterInfo: [],
      currentApplicant: '',
      uid: '',
      reviews: [],
      all_reviews: [],
      selectOption: 'None',
      selectOptions: [
        {
          value: 'None',
          label: 'None'
        },
        {
          value: 'university',
          label: 'Degree Institution'
        },
        {
          value: 'institution',
          label: 'Affiliation Institution'
        },
        {
          value: 'name',
          label: 'Applicant Name'
        },
        {
          value: 'jobid',
          label: 'Job ID'
        },
        {
          value: 'email',
          label: "Email"
        }
      ],
      statusSelectOption: [],
      statusSelectOptions: [{
        value: "",
        label: 'All'
      },
        {
          value: [13],
          label: '0 Review'
        },
        {
          value: [7],
          label: 'Decline'
        },
        {
          value: [5],
          label: 'Insufficient Reviews'
        },
        {
          value: [6],
          label: 'Interview'
        },
        {
          value: [9],
          label: 'Offer'
        },
        {
          value: [3],
          label: 'Pending'
        },
        {
          value: [8],
          label: 'Ref Needed'
        },
        {
          value: [12],
          label: 'Shortlist'
        },
        {
          value: [4],
          label: 'Sufficient Reviews'
        },
        // {
        //   value: [1, 2],
        //   label: ' '
        // },
        // {
        //   value: 2,
        //   label: 'Reference Complete'
        // },
      ],
      searchKeyWord: '',
      total: 0,
      tableParameter: {
        numberHeaderWidth: 65,
      },
      preboardingFlag: false,
      hkEngineerHeight: '0px',
      hkBusinessHeight: '0px',
      hkIPOHeight: '0px',
      gzInfoHubHeight: '0px',
      gzSociHubHeight: '0px',
      gzPriorityHeight: '0px',
      gzEduSciHeight: '0px',
      currentDeclinedRequester: null
    }
  },
  watch: {
    'gzThrustSelectorFlag': {
      handler: function (val) {
        if (val) {
          this.synchornizeHeightsGZ();
        }
      },
    },
    'hkThrustSelectorFlag': {
      handler: function (val) {
        if (val) {
          this.synchornizeHeightsHK();
        }
      },
    },
    'pointsOption': {
      handler: function (val) {
        if (val) {
          console.log(val)
          this.rearrangeReviewsWithPointsOption()
          for (var i = 0; i < this.reviews.length; i++) {
            this.collapseExpand.push('comment_' + i.toString())
          }
        }
      },
    },
    'referToOtherName': {
      handler: function (val) {
        if (val) {
          if (this.accessNameEmail.hasOwnProperty(val)) {
            this.referToOtherEmail = this.accessNameEmail[val]
          }
        }
      },
      deep: true
    },
    'viewMode': {
      handler: function (val) {
        if (val) {
          if (val == 'all') {
            this.referToListFlag = false
            this.declineRecommendFlag = false
            this.initData()
          } else if (val == 'decline') {
            this.referToListFlag = false
            this.declineRecommendFlag = true
            this.currentPage = 1
            this.initDeclineData()
          } else {
            this.referToListFlag = true
            this.declineRecommendFlag = false
            if (this.applicantList.length != 0) {
              this.initData()
            } else {
              this.records = []
              this.total = 0
            }
          }
        }
      },
      deep: true
    },
  },
  methods: {
    // async toECheckList(){
    //   let params = {
    //     username: this.currentApplicant
    //   }
    //   let fetchResponse = await this.$request.fetchECheckListByUsername(params)
    //   console.log(fetchResponse)
    //   if (fetchResponse) {
    //     // this.mainThrust = this.templateData.main_thrust
    //     let routeData = this.$router.resolve({
    //       name: "eCheckList",
    //       query: { cid: fetchResponse.data.cid, unitList: JSON.stringify(this.personalData.thrust) },
    //       params: { applicantId: this.currentApplicant }
    //     });
    //     window.open(routeData.href, "_blank");
    //   }
    // },
    displayDegreeInfoTimeRange(endtime) {
      if (endtime) {
        return endtime.split("-")[0]
      } else {
        return '-'
      }
    },
    synchornizeHeightsGZ() {
      console.log(this.$refs)
      this.$nextTick(() => {
        if (this.$refs['gzInfoHub'])
          this.gzInfoHubHeight = this.$refs['gzInfoHub'].$el.clientHeight + 'px';
        if (this.$refs['gzSociHub'])
          this.gzSociHubHeight = this.$refs['gzSociHub'].$el.clientHeight + 'px';
        if (this.$refs['gzPriority'])
          this.gzPriorityHeight = this.$refs['gzPriority'].$el.clientHeight + 'px';
        if (this.$refs['gzEduSci'])
          this.gzEduSciHeight = this.$refs['gzEduSci'].$el.clientHeight + 'px';
      })
    },
    synchornizeHeightsHK() {
      console.log(this.$refs)
      this.$nextTick(() => {
        if (this.$refs['hkEngineerDept'])
          this.hkEngineerHeight = this.$refs['hkEngineerDept'].$el.clientHeight + 'px';
        if (this.$refs['hkBusinessDept'])
          this.hkBusinessHeight = this.$refs['hkBusinessDept'].$el.clientHeight + 'px';
        if (this.$refs['hkIPODept'])
          this.hkIPOHeight = this.$refs['hkIPODept'].$el.clientHeight + 'px';
      })
    },
    getPersonalInfo(data, declinedUnit, requester) {
      this.yAxisOffset = window.pageYOffset;
      if (this.declineRecommendFlag) {
        this.currentDeclinedUnit = declinedUnit
        this.currentDeclinedRequester = requester
        this.personalInfo(data)
      } else {
        this.personalInfo(data)
      }
    },
    declineUnitCampus(unit, areas) {
      for (let i = 0; i < areas.gz.length; i++) {
        if (areas.gz[i][0] == unit) {
          return 'gz'
        }
      }
      return 'hk'
    },
    scoredRow(row) {
      if (row.row.hasOwnProperty("reviewedFlag")) {
        if (row.row.reviewedFlag) {
          return 'success-row';
        }
      }
      return '';
    },
    deleteReferToOtherList(object) {
      this.referToOtherEmailList.splice(this.referToOtherEmailList.indexOf(object), 1);
    },
    AddReferToOtherToList() {
      if (this.referToOtherName != '' && this.referToOtherEmail != '') {
        this.referToOtherEmailList.push({"name": this.referToOtherName, "email": this.referToOtherEmail})
        this.referToOtherName = ''
        this.referToOtherEmail = ''
      } else {
        Message({
          message: "Please input Name and Email",
          type: "error"
        })
      }
    },
    compareTimeline(a, b) {
      if (a.time < b.time) {
        return -1;
      }
      if (a.time > b.time) {
        return 1;
      }
      return 0;
    },
    showTimeline() {
      let data = {
        applicant: this.currentApplicant,
        "thrustOrDept": {
          "gz": this.personalData.thrust,
          "hk": this.personalData.hk_thrust,
          "applicant": ["applicant"], // Get the timeline of applicant screenStatus
        }
      }
      let timeLineArray = []
      this.$request.fetchStatusTimeline(data).then(res => {
        let timeLineObject = res.data
        for (var key in timeLineObject) {
          if (timeLineObject.hasOwnProperty(key)) {
            for (let i = 0; i < timeLineObject[key]["timeline"].length; i++) {
              if (timeLineObject[key]["timeline"][i].hasOwnProperty("reviewer")) {
                timeLineArray.push({
                  "campus": timeLineObject[key]["campus"],
                  "thrustOrDept": timeLineObject[key]["thrustOrDept"],
                  "time": timeLineObject[key]["timeline"][i]["time"],
                  "status": this.statusJson[timeLineObject[key]["timeline"][i]["status"]],
                  "reviewer": timeLineObject[key]["timeline"][i]["reviewer"]
                })
              } else {
                timeLineArray.push({
                  "campus": timeLineObject[key]["campus"],
                  "thrustOrDept": timeLineObject[key]["thrustOrDept"],
                  "time": timeLineObject[key]["timeline"][i]["time"],
                  "status": this.statusJson[timeLineObject[key]["timeline"][i]["status"]]
                })
              }
            }
          }
        }
        timeLineArray = timeLineArray.sort(this.compareTimeline)
      }).catch((err) => {
        console.log(err, 'Relogin Needed!')
        this.logout()
      })
    },
    updatePersonalData() {
      this.infoFlag = false
      this.personalInfo(this.currentApplicant)
    },
    updatePersonalDataDocumentChanged() {
      this.documentFlag = false
      this.personalInfo(this.currentApplicant)
    },
    roleHandler(roles) {
      let roleResult = {}
      for (var k in roles) {
        if (roles[k].length == 1) {
          roleResult[k] = roles[k][0]
        } else {
          roleResult[k] = this.privilegeRank(roles[k])
        }
      }
      return roleResult
    },
    privilegeRank(rankList) {
      if (rankList.includes("Thrust Admin")) {
        return "Thrust Admin"
      }
      if (rankList.includes("Admin")) {
        return "Admin"
      } else if (rankList.includes("Dean")) {
        return "Dean"
      } else if (rankList.includes("Head") || rankList.includes("Search Committee Chair")) {
        return "Head"
      } else if (rankList.includes("Search Committee Member")) {
        return "Search Committee Member"
      } else if (rankList.includes("Reviewer")) {
        return "Reviewer"
      } else {
        Message({
          message: "Role Error for current account, please contact System Admin",
          type: "error"
        })
        this.logout()
      }
      // for(let i = 0; i < rankList.length; i++){
      //   if(rankList[i] == "Provost" || rankList[i] == "VIPA" || rankList[i] == "SystemAdmin"){
      //     return rankList[i]
      //   }
      // }
    },
    previousPoints(reviews, unit, campus) {
      if (reviews) {
        for (let i = 0; i < reviews.points.length; i++) {
          if (reviews.points[i][2] == campus && reviews.points[i][0] == unit) {
            return reviews.points[i][1]
          }
        }
      }
      return undefined
    },
    keyCount(obj) {
      let size = 0;
      for (let k in obj) {
        console.log(k)
        size++
      }
      return size;
    },
    unitRoleDetection(unit, roleName) {
      if (this.currentRoleList.hasOwnProperty(this.getAbbreviationOriginal(unit))) {
        if (this.currentRoleList[this.getAbbreviationOriginal(unit)] == roleName) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    unitAvailability(unit) {
      // console.log(this.currentAvailableThrust.includes(this.correctThrust(unit)))
      return this.currentAvailableThrust.includes(this.correctThrust(unit))
    },
    getTableCellStyle() {
      return 'border-color: grey;'
    },
    highPrivilegeCondition() {
      if (this.referToListFlag) {
        return true
      }
      if (this.currentRoleList.hasOwnProperty("ALL")) {
        if (this.currentRoleList["ALL"] == 'Provost' || this.currentRoleList["ALL"] == 'VPIA' || this.currentRoleList["ALL"] == 'SystemAdmin') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    roleListForDeclineData(currentRoleList) {
      let result = {}
      for (var key in currentRoleList) {
        if (currentRoleList.hasOwnProperty(key)) {
          if (currentRoleList[key] == "Head" || currentRoleList[key] == "Dean" || currentRoleList[key] == "Search Committee Chair") {
            result[key] = currentRoleList[key]
          }
        }
      }
      return result
    },
    initDeclineData(fetchParameter) {
      this.loadingFlag = true
      if (!fetchParameter) {
        fetchParameter = {
          unitRole: this.roleListForDeclineData(this.currentRoleList),
          userId: this.uid,
          sortedKey: "received",
          order: "desc",
          pageNum: this.currentPage,
          NumOfElement: this.pageItemNum,
          parameterList: ["affiliation_institution", "affiliation_position", "affiliation_period", "academic_info"],
        }
      }
      this.$request.getRequestDeclineList(fetchParameter).then(res => {
        if (res.data) {
          console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].timeLine = [this.timeTranslate(res.data[i].received), '(' + this.timeTranslate(res.data[i].lastUpdated) + ')']
            // res.data[i].campus = this.campus
          }
          this.endInitDataWithTokenInfo(res)
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Error",
          type: "error"
        })
        this.logout()
      });
    },
    initData() {
      this.loadingFlag = true
      this.calculateThrustLength()
      this.campusDetailHandler()
      let fetchParameter = {
        campus: this.campusDetail,
        uid: this.uid,
        sortedKey: "received",
        order: "desc",
        pageNum: this.currentPage,
        NumOfElement: this.pageItemNum,
        parameterList: ["affiliation_institution", "affiliation_position", "affiliation_period", "academic_info"],
        type: this.positions
      }
      if (this.qdeclinedSwitch) {
        fetchParameter.specialRequire = 11
      }
      if (this.referToListFlag) {
        fetchParameter['applicants'] = this.applicantList
        // fetchParameter['type'] = ["Full Professor", "Associate Professor", "Assistant Professor","Research Track","Teaching Track","Visiting Faculty"]
      }
      console.log("fetchParameter")
      console.log(fetchParameter)
      if (this.referToOnlyFlag && this.applicantList.length == 0) {
        let emptyRes = {"data": {}}
        emptyRes.data.data = []
        emptyRes.data.total = 0
        this.endInitDataWithTokenInfo(emptyRes)
        // this.logout()
        return
      }
      if (this.campusDetail.gz.length == 0 && this.campusDetail.hk.length == 0 && !this.highPrivilegeCondition() && this.applicantList.length == 0) {
        Message({
          message: "No unit is listed",
          type: "error"
        })
        let emptyRes = {"data": {}}
        emptyRes.data.data = []
        emptyRes.data.total = 0
        this.endInitDataWithTokenInfo(emptyRes)
        // this.logout()
        return
      }
      this.$request.fetchCandidates(fetchParameter).then(res => {
        if (res.data) {
          console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].timeLine = [this.timeTranslate(res.data[i].received), '(' + this.timeTranslate(res.data[i].lastUpdated) + ')']
            res.data[i].campus = this.campus
          }
          this.endInitDataWithTokenInfo(res)
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Error",
          type: "error"
        })
        this.logout()
      });
    },
    endInitDataWithTokenInfo(res) {
      let accessToken = this.$cookies.get("access_token");
      if (accessToken) {
        this.$request.fetchUserByToken({"token": accessToken}).then(res2 => {
          if (res2.data) {
            console.log("fetchUserByToken")
            console.log(res2.data)
            // this.uid = res2.data.uid;
            this.records = this.areasHandler(res.data.data)
            if (!this.declineRecommendFlag)
              this.getHighestDegrees(this.records)
            this.total = res.data.total
            this.loadingFlag = false
          }
        }).catch((err) => {
          console.log(err, 'Relogin Needed!')
          this.logout()
        })
      } else {
        this.logout()
      }
    },
    showReference() {
      this.referenceEmailFlag = true
    },
    getReviewerName(review, index) {
      for (let i = 0; i < review.points.length; i++) {
        if (!this.unitRoleDetection(review.points[i][0], "Reviewer") && !this.referToListFlag) {
          return review.reviewerName + ' (' + this.getMaximumUpdateTimeForReview(review).toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          }) + ")"
        }
      }
      return 'Reviewer ' + (index + 1) + ' (' + this.getMaximumUpdateTimeForReview(review).toLocaleString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }) + ")"
    },
    status(statusCode) {
      if (this.statusJson.hasOwnProperty(statusCode)) {
        if (statusCode === this.statusNameJson["Sufficient Review"]) {
          return ' ✓'
        } else if (statusCode === this.statusNameJson["Insufficient Review"]) {
          return ''
        } else if (statusCode === this.statusNameJson["Interview"]) {
          return ' 👍'
        } else if (statusCode === this.statusNameJson["Decline"]) {
          return ' ✖'
        } else if (statusCode === this.statusNameJson["Offer"]) {
          return ' ★'
        } else if (statusCode === this.statusNameJson["Shortlist"]) {
          return ' *'
        } else {
          return ' ?'
        }
      } else {
        return ' ?'
      }
    },
    clearRelationship() {
      this.relation = ''
      this.otherRelation = ''
    },
    refresh() {
      location.reload();
    },
    logout() {
      console.log("cookie data")
      console.log(this.$cookies.get("username"))
      console.log(this.$cookies.get("identity"))
      const authenticationType = this.$cookies.get("scnmbr_auth_type")
      let that = this;
      this.$request.screenMemberLogout(authenticationType).then(res => {
        console.log(res);
        console.log(typeof res);
        Message({
          message: "Successfully Logout!",
          type: "success"
        })
        const ssoLogoutUrl = res.data;
        console.log(that.$cookies.get("identity"))
        if (that.screenIdentity) {
          if ((that.screenIdentity === "external")) {
            that.$router.push({path: "/external-login-screening"});
          } else {
            if (that.$cookies.get("scnmbr_auth_type") === "sso" && ssoLogoutUrl) {
                window.location.href = ssoLogoutUrl.url;
            } else {
              that.$router.push({path: "/login-screening"});
            }
          }
        } else {
          if (that.$cookies.get("scnmbr_auth_type") === "sso" && ssoLogoutUrl) {
            window.location.href = ssoLogoutUrl.url;
          } else {
            that.$router.push({path: "/login-screening"});
          }
        }
        that.$cookies.keys().forEach(cookie => that.$cookies.remove(cookie))
        Vue.prototype.$serverAccessToken = ""
      }, 'success').catch((err) => {
        console.log(err)
        that.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
        Vue.prototype.$serverAccessToken = ""
        that.$router.push({path: "/login-screening"});
      });
    },
    departmentDataUpdateHandler(content, dataNotation) {
      this.campusDetail[dataNotation] = content
      console.log(content)
      if (dataNotation === "gz") {
        if (this.gzLengthOriginal == this.campusDetail.gz.length) {
          this.gzIndeterminate = false
          this.gzCheckAll = true
        } else if (this.campusDetail.gz.length == 0) {
          this.gzIndeterminate = false
          this.gzCheckAll = false
        } else {
          this.gzIndeterminate = true
        }
      }
      if (dataNotation === "hk") {
        if (this.hkLengthOriginal == this.campusDetail.hk.length) {
          this.hkIndeterminate = false
          this.hkCheckAll = true
        } else if (this.campusDetail.hk.length == 0) {
          this.hkIndeterminate = false
          this.hkCheckAll = false
        } else {
          this.hkIndeterminate = true
        }
      }
      this.campusThrustsConnect()
    },
    areasHandler(records) {
      // if(this.highPrivilegeCondition()){
      //   for(let r = 0; r < records.length; r ++){
      //     for(let i = records[r].areas.gz.length - 1; i > -1; i--){
      //       console.log(records[r].areas.gz[i])
      //       if(!this.currentAvailableThrust.includes(records[r].areas.gz[i][0])){
      //         records[r].areas.gz.splice(i,1)
      //       }
      //     }
      //     for(let i = records[r].areas.hk.length - 1; i > -1; i--){
      //       if(!this.currentAvailableThrust.includes(records[r].areas.hk[i][0])){
      //         console.log(records[r].areas.hk[i])
      //         records[r].areas.hk.splice(i,1)
      //       }
      //     }
      //   }
      // }
      return records
    },
    reviewPointsOptionDetect(review) {
      let count = 0
      console.log("detect " + this.pointsOption.toString())
      for (let i = 0; i < review.points.length; i++) {
        console.log(this.getAbbreviation(review.points[i][0]))
        if (this.pointsOption.includes(this.getAbbreviation(review.points[i][0]))) {
          count = count + 1
        }
      }
      if (count === 0)
        return false
      else
        return true
    },
    getPointsOptions(reviews) {
      let all_unit = []
      this.pointsOptions = []
      let currentOptions = []
      for (let i = reviews.length - 1; i > -1; i--) {
        for (let j = reviews[i].points.length - 1; j > -1; j--) {
          if (!currentOptions.includes({
            value: [reviews[i].points[j][0]],
            label: this.getAbbreviation(reviews[i].points[j][0])
          })) {
            currentOptions.push(
                {
                  value: [this.getAbbreviation(reviews[i].points[j][0])],
                  label: this.getAbbreviation(reviews[i].points[j][0])
                })
          }
          if (!all_unit.includes(this.getAbbreviation(reviews[i].points[j][0]))) {
            all_unit.push(this.getAbbreviation(reviews[i].points[j][0]))
          }
        }
      }
      currentOptions.unshift(
          {
            value: all_unit,
            label: 'All Reviews'
          })
      const key = 'label';
      this.pointsOptions = [...new Map(currentOptions.map(item =>
          [item[key], item])).values()];
      this.pointsOption = this.pointsOptions[0].value
    },
    deepCopy(src) {
      let target = Array.isArray(src) ? [] : {};
      for (let key in src) {
        let v = src[key];
        if (v) {
          if (typeof v === "object") {
            target[key] = this.deepCopy(v);
          } else {
            target[key] = v;
          }
        } else {
          target[key] = v;
        }
      }
      return target;
    },
    rearrangeReviewsWithPointsOption() {
      // this.reviews = this.deepCopy(this.all_reviews)
      let reviews = this.all_reviews
      this.reviews = []
      for (let i = reviews.length - 1; i > -1; i--) {
        let point_object = this.deepCopy(reviews[i])
        for (let j = point_object.points.length - 1; j > -1; j--) {
          if (!this.pointsOption.includes(this.getAbbreviation(reviews[i].points[j][0]))) {
            point_object.points.splice(j, 1)
          }
        }
        if (point_object.points.length != 0) {
          this.reviews.push(point_object)
        }
      }
      this.reviews.sort(this.reviewsCompare)
    },
    getMaximumUpdateTimeForReview(review) {
      let commentUpdateTime = new Date(review.commentUpdateTime)
      let pointUpdateTime = new Date(review.pointUpdateTime)
      if (commentUpdateTime > pointUpdateTime) {
        return commentUpdateTime
      } else {
        return pointUpdateTime
      }
    },
    reviewsCompare(a, b) {
      const timeA = this.getMaximumUpdateTimeForReview(a);
      const timeB = this.getMaximumUpdateTimeForReview(b);

      let comparison = 0;
      if (timeA > timeB) {
        comparison = -1;
      } else if (timeA < timeB) {
        comparison = 1;
      }
      return comparison;
    },
    // sortInUpdateOrder(reviews){
    //
    // },
    rearrangeReviews(reviews) {
      if (this.highPrivilegeCondition()) {
        return reviews
      }
      console.log("this.thrustPoints")
      console.log(this.thrustPoints)
      for (let i = reviews.length - 1; i > -1; i--) {
        console.log('before')
        console.log(reviews[i])
        for (let j = reviews[i].points.length - 1; j > -1; j--) {
          if (!this.unitAvailability(reviews[i].points[j][0])) {
            reviews[i].points.splice(j, 1)
          } else {
            if ((this.unitRoleDetection(reviews[i].points[j][0], "Search Committee Member")) && (this.thrustPoints[reviews[i].points[j][2]][reviews[i].points[j][0]].numOfReviewer < 3)) {
              reviews[i].points.splice(j, 1)
            }
            if (this.unitRoleDetection(reviews[i].points[j][0], "Reviewer")) {
              reviews[i].points.splice(j, 1)
            }
          }
        }
        console.log('after')
        console.log(reviews[i])
        if (reviews[i].points.length == 0) {
          reviews.splice(i, 1)
        }
      }
      return reviews
    },
    submitComment() {
      let points = []
      for (let i = 0; i < this.gzScoreDocuments.length; i++) {
        if (this.gzScoreDocuments[i].score !== undefined)
          points.push([this.gzScoreDocuments[i].name, "gz", this.gzScoreDocuments[i].score])
      }
      for (let i = 0; i < this.hkScoreDocuments.length; i++) {
        if (this.hkScoreDocuments[i].score !== undefined)
          points.push([this.hkScoreDocuments[i].name, "hk", this.hkScoreDocuments[i].score])
      }
      var relationship = ''
      if (this.relation === 'Others') {
        if (this.otherRelation != "") {
          relationship = this.relation + "(" + this.otherRelation + ")"
        } else {
          Message({
            message: "Please specify relation",
            type: "error"
          })
          return
        }
      } else
        relationship = this.relation
      if (points.length > 0) {
        let commentParameter = {
          reviewer: this.uid,
          applicant: this.currentApplicant,
          comment: this.comment,
          points: points,
          relationship: relationship
        }
        this.$request.submitReviewResult(commentParameter).then(res => {
          if (res.data) {
            console.log(res)
            Message({
              message: "Review Submitted",
              type: "success"
            })
            this.changeSort(this.val, "update")
            this.comment = ""
            this.relation = ""
            this.otherRelation = ""
            this.commentFlag = false
            this.personalInfo(this.currentApplicant)
          }
        }).catch((err) => {
          console.log(err)
          Message({
            message: "Review Submit Error",
            type: "error"
          })
        });
      } else {
        Message({
          message: "Please rate at least one unit",
          type: "error"
        })
      }
      // this.infoFlag = true
    },
    showComment() {
      let commentParameter = {
        applicantID: this.currentApplicant,
        reviewerID: this.uid,
      }
      this.$request.reviewDetails(commentParameter).then(res => {
        if (res.data) {
          console.log(res)
          let scoreRecord = res.data[0]
          if (scoreRecord) {
            this.comment = scoreRecord.comment
            this.relation = scoreRecord.relationship
          }
          this.gzScoreDocuments = []
          this.hkScoreDocuments = []
          for (let i = 0; i < this.personalData.thrust.length; i++) {
            if ((this.unitAvailability(this.personalData.thrust[i]) && !this.unitRoleDetection(this.personalData.thrust[i], "Admin") && !this.unitRoleDetection(this.personalData.thrust[i], "Thrust Admin")) || this.highPrivilegeCondition()) {
              this.gzScoreDocuments.push({
                name: this.personalData.thrust[i],
                score: this.previousPoints(scoreRecord, this.personalData.thrust[i], "gz")
              })
            }
          }
          for (let j = 0; j < this.personalData.hk_thrust.length; j++) {
            if ((this.unitAvailability(this.personalData.hk_thrust[j]) && !this.unitRoleDetection(this.personalData.hk_thrust[j], "Admin") && !this.unitRoleDetection(this.personalData.hk_thrust[j], "Thrust Admin")) || this.highPrivilegeCondition()) {
              this.hkScoreDocuments.push({
                name: this.personalData.hk_thrust[j],
                score: this.previousPoints(scoreRecord, this.personalData.hk_thrust[j], "hk")
              })
            }
          }
          if (this.hkScoreDocuments.length == 0 && this.gzScoreDocuments == 0) {
            Message({
              message: "Currently there is no unit to score",
              type: "error"
            })
          } else {
            this.infoFlag = false
            this.commentFlag = true
          }
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Error",
          type: "error"
        })
      });
    },
    async showECheckList() {
      let params = {
        username: this.currentApplicant
      }
      let fetchResponse = await this.$request.fetchECheckListByUsername(params)
      console.log(fetchResponse)
      if (fetchResponse) {
        // this.mainThrust = this.templateData.main_thrust
        if(!fetchResponse.data.cid){
          this.infoFlag = false
          this.eCheckListFlag = true
        }
        else{
          let routeData = this.$router.resolve({
            name: "eCheckList",
            query: { cid: fetchResponse.data.cid, unitList: JSON.stringify(this.personalData.thrust) },
            params: { applicantId: this.currentApplicant }
          });
          window.open(routeData.href, "_blank");
        }
      }
      // this.toECheckList()
    },
    closeECheckList(){
      this.eCheckListFlag = false
      this.infoFlag = true
    },
    showDocuments() {
      this.infoFlag = false
      this.documentFlag = true
    },
    getReviewDetail() {
      let reviewParameter = {
        applicantID: this.currentApplicant,
        reviewerID: ""
      }
      this.$request.reviewDetails(reviewParameter).then(res => {
        if (res.data) {
          // console.log(res)
          this.all_reviews = this.rearrangeReviews(res.data)
          this.infoFlag = false
          this.commentDetailFlag = true
          this.getPointsOptions(this.all_reviews)
          // this.reviews = res.data
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Error",
          type: "error"
        })
      });
    },
    clearDocuments(documents) {
      let submittedList = []
      let submittedDocuments = []
      for (let i = 0; i < documents.length; i++) {
        if (documents[i].submitted == true && documents[i].filename != "")
          submittedList.push(i)
      }
      for (let j = 0; j < submittedList.length; j++) {
        submittedDocuments.push(documents[submittedList[j]])
      }
      return submittedDocuments
    },
    personalInfo(paramUserName) {
      console.log("applicant id " + paramUserName)
      this.$request.fetchPersonalData({username: paramUserName}).then(res => {
        if (res.data) {
          // console.log(res)
          if (res.data.data.email) {
            res.data.data.email = this.aesDecrypt(res.data.data.email)
          }
          this.originalDocuments = res.data.data.documents
          res.data.data.documents = this.clearDocuments(res.data.data.documents)
          if (res.data.refereeLetters.length != 0) {
            res.data.data.documents.push(
                {
                  "display_name": "Reference Letter",
                  "sub_file": false,
                  "parent": true,
                  "size_limit": 2,
                  "submitted": false
                },
            )
            this.originalDocuments.push(
                {
                  "display_name": "Reference Letter",
                  "sub_file": false,
                  "parent": true,
                  "size_limit": 2,
                  "submitted": false
                },
            )
            for (let i = 0; i < res.data.refereeLetters.length; i++) {
              res.data.refereeLetters[i].display_name = res.data.refereeLetters[i].refereeName
              res.data.refereeLetters[i].sub_file = true
              if (res.data.refereeLetters[i].submitted) {
                res.data.data.documents.push(res.data.refereeLetters[i])
              }
              this.originalDocuments.push(res.data.refereeLetters[i])
            }
          }
          this.personalData = res.data.data
          this.qDeclineReviewerInfo = res.data.QDeclineReviewerInfo
          this.thrustPoints = res.data.thrustsPoints
          this.referenceLetterInfo = res.data.refereeLetters
          this.currentApplicant = paramUserName
          this.thrustStatus = res.data.thrustsStatus
          this.referToOtherEmailList = []
          this.infoFlag = true
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Not Authorized Access, Please Login!",
          type: "error"
        })
        this.logout();
      });
    },
    // campusLengthCheck(){
    //   if(this.campusDetail.gz.length == 0 && this.campusDetail.hk.length == 0){
    //     Message({
    //       message: "Please choose at least on Unit",
    //       type: "error"
    //     })
    //     return true
    //   }
    //   else
    //     return false
    // },
    alphabetSearch(content) {
      if (this.campusDetail.gz.length == 0 && this.campusDetail.hk.length == 0) {
        Message({
          message: "Please choose at least one Unit",
          type: "error"
        })
        return
      }
      this.loadingFlag = true
      this.$refs.screeningTable.clearSort()
      let fetchParameter = {
        campus: this.campusDetail,
        uid: this.uid,
        sortedKey: "",
        order: "",
        pageNum: this.currentPage,
        NumOfElement: this.pageItemNum,
        parameterList: ["affiliation_institution", "affiliation_position", "affiliation_period", "academic_info"],
        searchKey: content,
        status: this.statusSelectOption,
        type: this.positions
      }
      if (this.qdeclinedSwitch) {
        fetchParameter.specialRequire = 11
      }
      let searchMethod = this.$request.fetchCandidatesByLastName(fetchParameter)
      searchMethod.then(res => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].timeLine = [this.timeTranslate(res.data[i].received), '(' + this.timeTranslate(res.data[i].lastUpdated) + ')']
            res.data[i].campus = this.campus
          }
          this.records = this.areasHandler(res.data.data)
          this.getHighestDegrees(this.records)
          this.total = res.data.total
          this.loadingFlag = false
          this.gzThrustSelectorFlag = false
          this.hkThrustSelectorFlag = false
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Error",
          type: "error"
        })
        this.logout()
      });
    },
    currentSort() {
      this.changeSort(this.val, "update")
    },
    changeSort(val, type) {
      if (this.campusDetail.gz.length == 0 && this.campusDetail.hk.length == 0 && !this.declineRecommendFlag) {
        Message({
          message: "Please choose at least one Unit",
          type: "error"
        })
        return
      }
      this.loadingFlag = true
      let order = ''
      order = val.order == 'ascending' ? 'asc' : 'desc'
      if (val == 'search') {
        if (val == 'search') {
          this.currentPage = 1
        }
        this.currentOrder = {"prop": "", "order": ""}
        val = {"prop": ""}
        order = ""
        this.$refs.screeningTable.clearSort()
      } else {
        this.currentOrder = val
      }
      if (this.declineRecommendFlag) {
        let fetchParameter = {
          unitRole: this.currentRoleList,
          userId: this.uid,
          sortedKey: val.prop,
          order: order,
          pageNum: this.currentPage,
          NumOfElement: this.pageItemNum,
          parameterList: ["affiliation_institution", "affiliation_position", "affiliation_period", "academic_info"]
        }
        this.initDeclineData(fetchParameter)
        return
      }
      let fetchParameter = {
        campus: this.campusDetail,
        uid: this.uid,
        sortedKey: val.prop,
        order: order,
        pageNum: this.currentPage,
        NumOfElement: this.pageItemNum,
        status: this.statusSelectOption,
        parameterList: ["affiliation_institution", "affiliation_position", "affiliation_period", "academic_info"],
        type: this.positions
      }
      var searchMethod;
      if (this.referToListFlag) {
        fetchParameter['applicants'] = this.applicantList
        searchMethod = this.$request.fetchCandidates(fetchParameter)
      } else {
        if (this.qdeclinedSwitch) {
          fetchParameter.specialRequire = 11
        }
        if (this.searchKeyWord != '' && this.selectOption != 'None') {
          fetchParameter["searchKey"] = this.searchKeyWord
          if (this.selectOption === 'university') {
            searchMethod = this.$request.fetchCandidatesByUniversity(fetchParameter)
          } else if (this.selectOption === 'institution') {
            searchMethod = this.$request.fetchCandidatesByAffiliation(fetchParameter)
          } else if (this.selectOption === 'name') {
            searchMethod = this.$request.fetchCandidatesByName(fetchParameter)
          } else if (this.selectOption === 'jobid') {
            searchMethod = this.$request.fetchCandidatesByJobID(fetchParameter)
          } else if (this.selectOption === 'email') {
            searchMethod = this.$request.fetchCandidatesByEmail(fetchParameter)
          }
        } else {
          searchMethod = this.$request.fetchCandidates(fetchParameter)
        }
      }
      searchMethod.then(res => {
        if (res.data) {
          this.val = val
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].timeLine = [this.timeTranslate(res.data[i].received), '(' + this.timeTranslate(res.data[i].lastUpdated) + ')']
            res.data[i].campus = this.campus
          }
          this.records = this.areasHandler(res.data.data)
          this.getHighestDegrees(this.records)
          this.total = res.data.total
          this.loadingFlag = false
          this.gzThrustSelectorFlag = false
          this.hkThrustSelectorFlag = false
          if (type == "update") {
            window.scrollTo(0, this.yAxisOffset);
          }
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Error",
          type: "error"
        })
        this.logout()
      });
    },
  },
  created() {
    let loginParameter = {}
    if (this.$route.query.externalUsername !== "" && this.$route.query.externalUsername !== undefined) {
      loginParameter.username = this.$route.query.externalUsername
      loginParameter.confirmCode = this.$route.query.confirmCode
    }
    this.$request.screenMemberLogin(loginParameter).then(res => {
      // const res = this.$route.params.loginResponse
      console.log(res);
      this.setCookies(res.data.data.access_token, res.data.data.username)
      this.currentRoleList = this.roleHandler(res.data.data.unitRole.role)
      this.screenIdentity = res.data.data.identity
      this.uid = res.data.data.username
      if(res.data.data.offerAdmin){
        this.preboardingFlag = res.data.data.offerAdmin.role["preboarding-generate"].active
      }
      if (this.$cookies.get("applicant_list")) {
        this.applicantList = JSON.parse(this.$cookies.get("applicant_list"))
      } else {
        this.applicantList = res.data.data.assignedReviewJob
      }
      if (this.keyCount(this.currentRoleList) == 0 || ('SPECIAL' in this.currentRoleList && this.keyCount(this.currentRoleList) == 1)) {
        this.referToListFlag = true
        this.referToOnlyFlag = true
      }
      for (var unit in this.currentRoleList) {
        if (unit != "ALL" && unit != "SPECIAL") {
          this.currentAvailableThrust.push(this.reverseThrustAbbreviation(unit))
        }
      }
      this.initData()
    }).catch((err) => {
      console.log(err)
      this.logout()
    });
  }
}
</script>

<style scoped>
@import "css/center.css";

.record-table {
  width: 100%;
  font-size: 1.5vh;
  font-weight: bold
}

.empty-class {
  height: 90vh;
}

@font-face {
  font-family: 'Verdana';
  src: url('../../assets/fonts/Verdana/verdana.ttf') format('truetype')
}

.screening-font {
  /*font-family: 'Verdana', 'Muli', 'Microsoft JhengHei', "\5FAE\8EDF\6B63\9ED1\9AD4", sans-serif;*/
  font-family: 'Verdana', 'Muli', "\5FAE\8EDF\6B63\9ED1\9AD4", sans-serif;
}

.list-gold-tag {
  margin-left: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-color: #946F34
}

.list-green-tag {
  margin-left: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-color: #27AE60
}

</style>
